import { useQuery } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { SearchResult } from '@/types/dto/SearchResult';

const useSearchHistory = (enabled: boolean = true) => {
  const queryKey = ['search_history'];

  const queryFn = async () => {
    return getSearchHistory();
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useSearchHistory;

async function getSearchHistory(): Promise<SearchResult[]> {
  try {
    const response = await BackendClient.get<BackendSuccessResponse<SearchResult[]>>('/api/chat/search-history');

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while fetching search history.');
  }
}
